function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandLogo12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 173,
    height: 173,
    viewBox: "0 0 173 173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "go2nx89qja"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8516",
    transform: "translate(1465 6390)",
    style: {
      fill: "#fff",
      stroke: "#707070"
    },
    d: "M0 0h173v173H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 162",
    transform: "translate(-1465 -6390)",
    style: {
      clipPath: "url(#go2nx89qja)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-25.331 0c-17.146 0-20.511 3.319-24.2 15.414l-6.482 21.543q-.222.783-.409 1.528a31.952 31.952 0 0 0-1.149 7.246 12.1 12.1 0 0 0 1.149 5.624c2.028 3.932 7.133 6.247 18.293 6.247C-21.146 57.6-17.7 54.4-14.5 44.268l3.035-9.841h-17.474l-1.807 6.073c-.818 2.362-1.311 4.614-4.84 4.614-2.38 0-3.608-1.856-2.789-4.276l6.811-23.512c.654-2.364 1.39-4.614 4.919-4.614 2.378 0 3.527 1.8 2.791 4.276l-2.216 7.928h17.555l1.394-4.616a33.68 33.68 0 0 0 1.558-8.888C-5.563 4.389-7.779 0-25.331 0",
    transform: "translate(1641.563 6448.001)",
    style: {
      fill: "#ee3425"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-39.96-4.3c-1.9-3.466-6.763-5.47-18.621-5.47-17.063 0-20.507 3.319-24.117 15.414l-6.562 21.545a56.576 56.576 0 0 0-.862 3.444 27.057 27.057 0 0 0-.7 5.328 13.43 13.43 0 0 0 .7 4.592c1.659 4.555 6.639 7.279 18.744 7.279 16.982 0 20.426-3.205 23.625-13.333l3.118-9.841h-17.558l-1.8 6.075c-.737 2.362-1.313 4.612-4.84 4.612-2.38 0-3.608-1.856-2.789-4.274l6.892-23.514c.573-2.362 1.392-4.614 4.919-4.614 2.3 0 3.527 1.8 2.708 4.276l-2.214 7.93h17.553l1.394-4.614q.225-.732.411-1.441a31.975 31.975 0 0 0 1.149-7.445A12.218 12.218 0 0 0-39.96-4.3",
    transform: "translate(1625.102 6457.766)",
    style: {
      fill: "#ee3425"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-34.742-26.255h-9.6l13.864-21.153h.575zm22.763-33.415h-27.195L-78.959-4.206h20.754l6.805-10.913h14.2l-2.465 10.913h19.689l8-51.015.7-4.45",
    transform: "translate(1546.959 6508.962)",
    style: {
      fill: "#ee3425"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogo12);
export default __webpack_public_path__ + "static/media/brand-logo-12.c6bf53bfd38d712c55da94fd107bfbc0.svg";
export { ForwardRef as ReactComponent };